import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 10.3 18.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.3 18.7\" id=\"icon-chevron-left\">\r\n<path d=\"M9.3,0C9.6,0,9.8,0.1,10,0.3c0.4,0.4,0.4,1,0,1.4L2.4,9.3L10,17c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0L0.3,10\r\n\tc-0.4-0.4-0.4-1,0-1.4l8.3-8.3C8.8,0.1,9.1,0,9.3,0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol